import { Columns } from '../interfaces/helpers';
import { ColumnConfig, IEntityMetadata } from '../interfaces/internal';
import { LanguagePage } from '../interfaces/types';

export class EntityMetadata implements IEntityMetadata {
  // eslint-disable-next-line @typescript-eslint/ban-types
  entity: Function | string;
  language: LanguagePage;
  hasMultiplePrimaryKeys = false;
  columns: ColumnConfig[] = [];

  constructor(args: IEntityMetadata) {
    this.entity = args.entity;
    this.columns = [...args.columns];
  }

  setColumn(column: ColumnConfig) {
    this.columns.push(column);
  }

  hasId(entity): boolean {
    if (!entity) {
      return false;
    }

    const primaryColumns = this.columns.filter((c) => c.isPrimaryKey);
    return primaryColumns.length > 0;
  }

  getTelusTableColumns(): Columns[] {
    return this.columns
      .filter((config) => config.table)
      .sort((a, b) =>
        a.table.defaultPosition > b.table.defaultPosition ? 1 : -1
      )
      .map((c) => {
        const column: Columns = {
          field: c.name,
          visible: !c.table.hide,
          type: c.type,
          hiddenFormField: c.form?.hide,
          hiddenTableField: !c.table.defaultPosition,
          isEditable: c.isEditable,
          position: c.table.defaultPosition,
        };

        return column;
      });
  }

  getTelusFormColumns() {
    return this.columns
      .filter((config) => config.form)
      .sort((a, b) =>
        a.form.defaultPosition > b.form.defaultPosition ? 1 : -1
      )
      .map((c) => {
        const column: Columns = {
          field: c.name,
          visible: !c.form.hide,
          type: c.type,
          hiddenFormField: c.form?.hide,
          hiddenTableField: !c.table?.defaultPosition,
          isEditable: c.isEditable,
          position: c.form.defaultPosition,
        };

        return column;
      });
  }
}
